
<template>
  <div class="autocomplete-container">
    <!-- optional indicators -->
    <!-- the input field -->
    <v-text-field
      color="primary"
      :label="label"
      class="subtitle-2"
      :placeholder="placeholder"
      v-model="query"
      autocomplete="off"
      :name="name"
      :id="name"
      :class="inputClass"
      @focus="onInputSelect"
      @keydown.down="down"
      @keydown.up="up"
      v-on:keydown.enter.prevent="onSelect"
      @keydown.esc="reset"
      @blur="reset"
      @input="updateTimeout"
      :hint="hint"
      :persistent-hint="persistentHint"
    >
    <template v-slot:append>
      <v-progress-circular size=22 v-if="loading" :indeterminate="loading" color="var(--v-anchor-base)" />
      <v-icon v-show="!loading && isDirty" color="var(--v-anchor-base)" class="fa-times" @click="resetField">mdi-close</v-icon>
      <v-icon v-show="isEmpty" color="var(--v-anchor-base)" class="fa-times">mdi-search-web</v-icon>
    </template>
    <template v-slot:append-outer v-if="appendAction">
      <slot name="autocomplete-actions"/>
    </template>
    </v-text-field>

    <!-- <span class="primary--text details-label text-none" v-if="!hideDetails">{{ searchDescription }}</span> -->
    <!-- the list -->
    <ul v-show="items && showItems" ref="autocompleteItems" class="pl-0 ml-0" :style="css">
      <li
        v-for="( item, index ) in items"
        :key="index"
        :class="activeClass(index)"
        class="auto-label pl-2"
        @mousedown="onSelect"
        @mousemove="setActive(index)"
      >
        <span class="description-text">
          <strong> {{ item[criteria] }} </strong> - {{ item[description] }} <i v-if="item.icon && item.icon !== '' && icon" aria-hidden="true" :class="`v-icon notranslate fa-times mdi ${item.icon} theme--light float-right`"></i>
        </span>
      </li>
      <li v-if="showNoItemsFound" class="auto-label pl-2">
        <span class="description-text" v-text="$t('autocomplete.noItemsFound')"/>
      </li>
    </ul>
  </div>
</template>

<script>
// import { EventBus } from '@/router/bus'

export default {
  name: 'autocomplete',
  data () {
    return {
      items: [],
      query: '',
      searchDescription: '',
      current: -1,
      loading: false,
      cancelSearch: false,
      itemSelected: false,
      data: {},
      minChars: 1,
      selectFirst: true,
      selected: false,
      css: '',
      above: null,
      showItems: true
    }
  },
  props: {
    value: {
      type: String
    },
    inputClass: {
      type: String
    },
    name: {
      type: String
    },
    url: {
      type: String
    },
    limit: {
      type: Number,
      default: 5
    },
    criteria: {
      type: String
    },
    description: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    appendAction: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    prepareResponseData: {
      type: Function
    },
    label: {
      type: String
    },
    queryParamName: {
      type: String,
      default: 'search'
    },
    icon: {
      type: Boolean,
      default: false
    },
    filterFunction: {
      type: Function
    }
  },
  computed: {
    isEmpty () {
      return !this.query
    },
    isDirty () {
      return !!this.query
    },
    showNoItemsFound () {
      return !this.itemSelected &&
              !this.loading &&
              this.selected &&
              (this.items == null || this.items.length === 0)
    }
  },
  methods: {
    updateTimeout () {
      clearTimeout(this.sendFilter)
      this.sendFilter = setTimeout(() => {
        this.update()
      }, 500)
    },
    isFunction (functionToCheck) {
      return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
    },
    update () {
      this.cancel()
      // this.itemSelected = false

      if (this.cancelSearch) {
        return
      }

      if (!this.query) {
        return this.reset()
      }

      if (this.minChars && this.query.length < this.minChars) {
        return
      }

      this.$emit('selected', this.query)
      this.loading = true
      this.selected = true

      this.fetch().then(
        (response) => {
          if (response) {
            let data = response
            data = this.isFunction(this.prepareResponseData) ? this.prepareResponseData(data) : this.prepareResponseDataDefault(data)
            this.current = -1
            this.loading = false
            const initialHeight = document.querySelector('.v-dialog') !== null ? document.querySelector('.v-dialog').scrollHeight : 0
            var self = this
            this.items = this.limit ? data.slice(0, this.limit) : data
            setTimeout(function () {
              if (self.above === null && initialHeight > 350) {
                const currentHeight = document.querySelector('.v-dialog') !== null ? document.querySelector('.v-dialog').scrollHeight : 0
                self.above = initialHeight !== currentHeight
              }
              self.showItems = false
              if (self.items.length === 0 && self.above) {
                self.css = `top: -${20}px`
              }
              if (self.above && self.items.length > 0) { self.css = `top: -${self.items.length * 45 - 20}px` }
              self.showItems = true
            })
            if (this.selectFirst) {
              this.down()
            }
          }
        },
        (error) => {
          console.log(error)

          this.loading = false
        })
    },
    fetch () {
      const param = this.isFunction(this.filterFunction) ? this.filterFunction(this.query) : this.queryParamName
      const url = param
        ? this.url
        : this.url + this.query
      const params = param
        ? Object.assign({ [param]: this.query }, this.data)
        : this.data
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url, { params })

      return Promise.race([cancel, request])
    },
    cancel () {
      // used to 'cancel' previous searches
    },
    reset () {
      this.selected = false

      if (this.itemSelected) { return }

      if (!this.cancelSearch) {
        this.resetField()
      }
    },
    resetField () {
      this.items = []
      this.loading = false
      this.itemSelected = false
      this.searchDescription = ''
      this.query = ''
      this.$emit('selected', null)
    },
    resetContents () {
      this.resetField()
    },
    setContents (contents) {
      this.query = contents
      this.itemSelected = true
    },
    setActive (index) {
      this.current = index
      // this.cancelSearch = true
      this.query = this.items[index][this.criteria]
      // this.$emit('resolved', this.items[index])
    },
    activeClass (index) {
      return {
        'primary lighten-2': this.current === index
      }
    },
    up () {
      if (this.current > 0) {
        this.current--
      } else if (this.current === -1) {
        this.current = this.items.length - 1
      } else {
        this.current = -1
      }
    },
    down () {
      if (this.current < this.items.length - 1) {
        this.current++
      } else {
        this.current = -1
      }
    },
    onInputSelect () {
      if (this.query !== '') {
        this.resetField()
        this.fetch()
      }

      if (this.itemSelected) return
      this.cancelSearch = false
      this.updateTimeout()
    },
    onSelect () {
      if (this.current !== -1) {
        // this.cancelSearch = true
        this.$emit('resolved', this.items[this.current])
        this.searchDescription = this.items[this.current][this.description] + ''
        this.query = this.items[this.current][this.criteria] + ' - ' + this.searchDescription

        this.$emit('selected', this.items[this.current])
        this.items = []
        this.itemSelected = true
      }
    },
    prepareResponseDataDefault (data) {
      return data.body.payload
    },
    validate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          return result
        }
      })
    }
  }
}
</script>
<style lang="scss" type="text/scss">
@import '~@/assets/scss/variables.scss';

.autocomplete-container {
  position: relative;

  .fa-times {
    cursor: pointer;
  }
  ul {
    position: absolute;
    padding: 0;
    margin-top: -40px;
    min-width: 100%;
    background-color: var(--v-cards-base);
    list-style: none;
    border-radius: 1px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    z-index: 1000;
    li {
      padding: 10px 16px;
      border-radius: 1px !important;
      border-bottom: 1px solid var(--v-border-base);
      cursor: pointer;
      margin-top: 0;
    }
    li:hover span {
      color: var(--v-caption-light-base) !important;
    }
    li:first-child {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    li:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      border-bottom: 0;
    }
  }

  .auto-label{
    font-size: 14px;
    font-weight: 500;
  }

  span {
    display: block;
  }
  .name {
    font-weight: 600;
    font-size: 14px;
  }
  .screen-name {
    font-style: italic;
  }
  .criteria-text{
    color: var(--v-caption-base);
    font-weight: 500 !important;
    font-size: 14px !important;
  }
  .description-text{
    color: var(--v-subcaption-base);
    font-weight: 400 !important;
    font-size: 12px !important;
  }
}
</style>
